import { ComponentProps, forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';

import cx from 'classnames';

import s from './index.module.css';

type Props = {
  open: boolean;
  arrowProps?: ComponentProps<'div'>;
} & ComponentProps<'div'>;

type Type = ForwardRefExoticComponent<Props & RefAttributes<HTMLDivElement>>;

const MenuRoot: Type = forwardRef((props, ref) => {
  const { children, open, arrowProps, ...rest } = props;

  return (
    <div {...rest} ref={ref} className={cx(s.container, { [s.open]: open }, rest.className)}>
      <div {...arrowProps} className={cx(s.arrow, arrowProps?.className)} />

      {children}
    </div>
  );
});

function Option(props: ComponentProps<'button'>) {
  return <button {...props} className={cx(s.option, props.className)} />;
}

export const Menu = Object.assign(MenuRoot, { Option });
